/* ============================================================
   กันไม่ให้เข้าหน้าที่ตำแหน่งไม่มีสิทธิ์ (พิมพ์ URL ตรง ๆ ก็เข้าไม่ได้)

   ใช้ 2 แบบ
     1) ระบุเมนูเอง   <PermissionGuard menu="erp_job_order"><JobOrder /></PermissionGuard>
     2) ให้เดาจาก URL <PermissionGuard><Outlet /></PermissionGuard>
============================================================ */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Result, Button, Spin, Flex } from "antd";
import { usePermission } from "../../store/context/permission-context";
import { menuKeyByPath } from "../../constant/menu";

const PermissionGuard = ({ menu, action = "view", children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { can, loading, roleName } = usePermission();

  const menuKey = menu || menuKeyByPath(pathname);

  if (loading) {
    return (
      <Flex justify="center" align="center" style={{ minHeight: 240 }}>
        <Spin />
      </Flex>
    );
  }

  /* ไม่อยู่ในทะเบียนเมนู = หน้าที่ไม่ได้คุมสิทธิ์ ปล่อยผ่าน */
  if (!menuKey) return children;

  if (!can(menuKey, action)) {
    return (
      <Result
        status="403"
        title="ไม่มีสิทธิ์เข้าถึง"
        subTitle={`ตำแหน่ง "${roleName || "-"}" ไม่ได้รับสิทธิ์เข้าดูเมนูนี้ กรุณาติดต่อผู้ดูแลระบบ`}
        extra={
          <Button type="primary" onClick={() => navigate("/modules")}>
            กลับหน้าหลัก
          </Button>
        }
      />
    );
  }

  return children;
};

export default PermissionGuard;
